import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { getTestLabels } from '../../utils/getTestLabels.js';
import style from './Heading.module.scss.js';

/**
 * [source code](https://src.private.zooplus.net/projects/FE/repos/ui-components/browse/src/components/Typography/Heading.tsx)
 */
const H1 = forwardRef((props, ref) => {
    const { children, className, ...otherProps } = props;
    const { componentTestLabel } = getTestLabels('H1');
    return (jsx("h1", { "data-zta": componentTestLabel, ref: ref, ...otherProps, className: classNames(style['z-h1'], className), children: children }));
});
H1.displayName = 'H1';
/**
 * [source code](https://src.private.zooplus.net/projects/FE/repos/ui-components/browse/src/components/Typography/Heading.tsx)
 */
const H2 = forwardRef((props, ref) => {
    const { children, className, ...otherProps } = props;
    const { componentTestLabel } = getTestLabels('H2');
    return (jsx("h2", { "data-zta": componentTestLabel, ref: ref, ...otherProps, className: classNames(style['z-h2'], className), children: children }));
});
H2.displayName = 'H2';
/**
 * [source code](https://src.private.zooplus.net/projects/FE/repos/ui-components/browse/src/components/Typography/Heading.tsx)
 */
const H3 = forwardRef((props, ref) => {
    const { children, className, ...otherProps } = props;
    const { componentTestLabel } = getTestLabels('H3');
    return (jsx("h3", { "data-zta": componentTestLabel, ref: ref, ...otherProps, className: classNames(style['z-h3'], className), children: children }));
});
H3.displayName = 'H3';
/**
 * [source code](https://src.private.zooplus.net/projects/FE/repos/ui-components/browse/src/components/Typography/Heading.tsx)
 */
const H4 = forwardRef((props, ref) => {
    const { children, className, ...otherProps } = props;
    const { componentTestLabel } = getTestLabels('H4');
    return (jsx("h4", { "data-zta": componentTestLabel, ref: ref, ...otherProps, className: classNames(style['z-h4'], className), children: children }));
});
H4.displayName = 'H4';

export { H1, H2, H3, H4 };
//# sourceMappingURL=Heading.js.map
